import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export function createMatPaginatorIntl(translate: TranslateService): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  const updateLabels = () => {
    translate
      .get(['global.table.itemsPerPage', 'global.table.nextPage', 'global.table.previousPage'])
      .subscribe((translations) => {
        paginatorIntl.itemsPerPageLabel = translations['global.table.itemsPerPage'];
        paginatorIntl.nextPageLabel = translations['global.table.nextPage'];
        paginatorIntl.previousPageLabel = translations['global.table.previousPage'];
        paginatorIntl.changes.next();
      });
  };

  updateLabels();
  translate.onLangChange.subscribe(() => updateLabels());

  return paginatorIntl;
}
